import React from 'react';
import LinearProgress from '@material-ui/core/LinearProgress';

const ProgressBar: React.FC<{ loading: boolean }> = ({ loading }) => <LinearProgress style={{ opacity: +loading }} />;

export default ProgressBar;
